<template>
    <div v-if="!isLoadingPage" class="screen-number container-screen">
        <div @click="onClickBack" class="loto__back">
            <img src="~ThemePath/images/chevron-left-green.png" />
            <div class="loto__back__title">
                {{ getTranslatedText("back") }}
            </div>
        </div>
        <div class="loto__title">{{ getTranslatedText(dataSource.title) }}</div>
        <div class="screen-number__market">
            <div 
                class="screen-number__market-item" 
                v-for="(item, index) in dataSource.markets" 
                :key="index"
                :class="{ active: selectedMarket && selectedMarket.market_id === item.market_id }"
                @click="onSelectMarket(item)"
            >
                <div class="screen-number__market-name">{{ getTranslatedText(item.market_name) }}</div>
            </div>
        </div>
        <div class="screen-number__box-btn-quick-pick">
            <ButtonCommon 
                :isNoHover="true" 
                value="Quick Pick"
                className="screen-number__btn-quick-pick"
                @on-click-button-common="onClickQuickPick"
            />
        </div>
        <div class="screen-number__list-box">
            <div 
                v-for="(_, pickIndex) in Array.from({ length: picks }, (_, i) => i)"
                class="screen-number__item-box"
                :key="pickIndex"
            >
                <div 
                    v-for="(number, index) in CT_PICK_3.DEFAULT_LIST_NUMBER" 
                    class="screen-number__item" 
                    :class="{ active: selection[pickIndex] === number }" 
                    :key="index"
                    @click="() => onSelectNumber(number, pickIndex)"
                >
                    {{ number }}
                </div>
            </div>
        </div>
         <div class="screen-number__footer no-bgr">
            <div class="screen-number__footer-action-price">
                <div class="screen-number__info">
                    <span class="screen-number__text bold">{{ getTranslatedText(dataSource.title) }}</span>
                    <span class="screen-number__text">{{ renderPrice(wager, 2) }}</span>
                </div>
                <input 
                    :value="renderPrice(wager, 2)" 
                    class="screen-number__input price" 
                    disabled="disabled"
                />
            </div>
         </div>
        <div class="screen-number__footer-action">
            <div class="screen-number__info">
                <span class="screen-number__text bold">{{ getTranslatedText("total") }}</span>
                <span class="screen-number__text bold">{{ renderPrice(totalWager, 2) }}</span>
            </div>
            <div class="screen-number__box-button">
                <ButtonCommon 
                    :isNoHover="true" 
                    :isLoading="$store.state.isLoadingAddCart" 
                    value="clear"
                    @on-click-button-common="onShowConfirmClear" 
                />
                <ButtonCommon 
                    :isNoHover="true" 
                    :isLoading="$store.state.isLoadingAddCart" 
                    type="error" 
                    value="add to cart" 
                    @on-click-button-common="onAddToCart"
                />
            </div>
        </div>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import EventBus from "@/utils/EventBus";
import ButtonCommon from "@/components/common/button/index.vue";
import LoadingScreen from "@/components/common/loading/index.vue";
import TitleCommon from "@/components/common/title/index.vue";
import { formatPrice, isArrayEmpty, isObjEmpty, isStrEmpty } from "@/utils/utils";
import { CT_PICK_3 } from "@/constants/lotto";
import { isObject } from "util";

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, LoadingScreen, TitleCommon },
    data() {
        return {
            isLoadingPage: true,
            dataSource: null,
            CT_PICK_3,
            selection: [],
            selectedMarket: null,
            picks: 0,
            wager: 0,
            totalWager: 0,
            maxPerBall: CT_PICK_3.DEFAULT_MAX_PER_BALL,
        };
    },
    created() {
        this.fetchData();
        EventBus.$on("on-clear-select-number", () => this.onClearSelectNumber());
    },
    destroyed() {
        EventBus.$off("on-clear-select-number");
    },
    methods: {
        fetchData() {
            const dataEvents = localStorage.getItem(CT_PICK_3.LOCAL_STORAGE_KEY);
            if(isStrEmpty(dataEvents)) {
                this.$router.push(CT_PICK_3.URL_PATH);
                return;
            }
            const dataEventsParse = JSON.parse(dataEvents);
            this.dataSource = dataEventsParse;
            this.selection = Array(this.picks).fill(undefined);

            if (!isArrayEmpty(this.dataSource.markets)) {
                this.selectedMarket = this.dataSource.markets[0];
                this.renderConfigFollowMarket(this.selectedMarket);
            }

            this.isLoadingPage = false;
        },

        onClickBack() {
            this.$router.push(CT_PICK_3.URL_PATH);
            localStorage.removeItem(CT_PICK_3.LOCAL_STORAGE_KEY);
        },

        renderConfigFollowMarket(market) {
            if(isObjEmpty(market)) return;

            const { config } = market;

            this.picks = config?.balls[1]?.picks[0] || CT_PICK_3.DEFAULT_NUMBER_PICKS;
            this.wager = config?.wager.display_min || CT_PICK_3.DEFAULT_WAGER;
            this.totalWager = parseInt(this.wager) * this.dataSource.event_id.length;
            this.maxPerBall = config?.balls[1]?.similar_picks?.max_per_ball || CT_PICK_3.DEFAULT_MAX_PER_BALL;
        },

        // action screen
        onClickQuickPick() {
            const newSelection = [];
            const numberList = [...this.CT_PICK_3.DEFAULT_LIST_NUMBER];

            // Create a new selection array to avoid reactivity issues
            for (let i = 0; i < this.picks; i++) {
                const randomIndex = Math.floor(Math.random() * numberList.length);
                newSelection.push(numberList[randomIndex]);
            }

            const similarPicks = this.selectedMarket?.config?.balls?.[1]?.similar_picks;
            if (!similarPicks) {
                this.selection = newSelection;
                return;
            }

            const minSimilarPicks = typeof similarPicks.min === "number" ? similarPicks.min : undefined;
            const maxSimilarPicks = typeof similarPicks.max === "number" ? similarPicks.max : undefined;

            const duplicateCount = () => newSelection.length - new Set(newSelection).size;
            const getDuplicateIndexes = () => {
                const counts = newSelection.reduce((acc, num) => {
                    acc[num] = (acc[num] || 0) + 1;
                    return acc;
                }, {});
                return newSelection
                    .map((value, idx) => ({ value, idx }))
                    .filter(item => counts[item.value] > 1)
                    .map(item => item.idx);
            };
            const getNonDuplicateIndexes = () => {
                const counts = newSelection.reduce((acc, num) => {
                    acc[num] = (acc[num] || 0) + 1;
                    return acc;
                }, {});
                return newSelection
                    .map((value, idx) => ({ value, idx }))
                    .filter(item => counts[item.value] === 1)
                    .map(item => item.idx);
            };

            // Case: no duplicates allowed (min=0 and max=0)
            if (minSimilarPicks === 0 && maxSimilarPicks === 0) {
                let tries = 0;
                while (duplicateCount() > 0 && tries < 10) {
                    const duplicateIndexes = getDuplicateIndexes();
                    if (isArrayEmpty(duplicateIndexes)) break;

                    const targetIndex = duplicateIndexes[Math.floor(Math.random() * duplicateIndexes.length)];
                    const usedNumbers = new Set(newSelection);
                    const availableUnique = numberList.filter(number => !usedNumbers.has(number));

                    if (isArrayEmpty(availableUnique)) break;

                    const replacementIndex = Math.floor(Math.random() * availableUnique.length);
                    newSelection[targetIndex] = availableUnique[replacementIndex];
                    tries += 1;
                }
            }
            // Case: min duplicates requirement
            else if (typeof minSimilarPicks === "number" && duplicateCount() < minSimilarPicks) {
                const nonDuplicateIndexes = getNonDuplicateIndexes();
                for (let i = 0; i < nonDuplicateIndexes.length && duplicateCount() < minSimilarPicks; i++) {
                    const targetIndex = nonDuplicateIndexes[i];
                    const randomExistingIndex = Math.floor(Math.random() * newSelection.length);
                    newSelection[targetIndex] = newSelection[randomExistingIndex];
                }
            }
            // Case: max duplicates limit
            else if (typeof maxSimilarPicks === "number" && duplicateCount() > maxSimilarPicks) {
                let tries = 0;
                while (duplicateCount() > maxSimilarPicks && tries < 10) {
                    const duplicateIndexes = getDuplicateIndexes();
                    if (isArrayEmpty(duplicateIndexes)) break;

                    const targetIndex = duplicateIndexes[Math.floor(Math.random() * duplicateIndexes.length)];
                    const usedNumbers = new Set(newSelection);
                    const availableUnique = numberList.filter(number => !usedNumbers.has(number));
                    const replacementPool = !isArrayEmpty(availableUnique) ? availableUnique : numberList.filter(number => number !== newSelection[targetIndex]);

                    if (isArrayEmpty(replacementPool)) break;

                    const replacementIndex = Math.floor(Math.random() * replacementPool.length);
                    newSelection[targetIndex] = replacementPool[replacementIndex];
                    tries += 1;
                }
            }

            this.selection = newSelection;
        },

        onShowConfirmClear() {
            const param = {
                description: "Are you sure you want to delete?",
                nameFunction: "on-clear-select-number",
            };
            EventBus.$emit("on-show-dialog", param);
        },

        onClearSelectNumber() {
            this.selection = Array(this.picks).fill(undefined);
        },

        validateSimilarPicks() {
            const similarPicks = this.selectedMarket?.config?.balls?.[1]?.similar_picks;
            if (!similarPicks) {
                return { valid: true };
            }

            const minSimilarPicks = typeof similarPicks.min === "number" ? similarPicks.min : undefined;
            const maxSimilarPicks = typeof similarPicks.max === "number" ? similarPicks.max : undefined;
            const validSelection = this.selection.filter(num => num !== undefined);
            const duplicateCount = validSelection.length - new Set(validSelection).size;

            if (minSimilarPicks === 0 && maxSimilarPicks === 0 && duplicateCount > 0) {
                return {
                    valid: false,
                    message: this.getTranslatedText("Les Deux numéros doivent être identiques"),
                };
            }

            if (typeof minSimilarPicks === "number" && minSimilarPicks > 0 && duplicateCount < minSimilarPicks) {
                return {
                    valid: false,
                    message: this.getTranslatedText(
                        "Les Deux numéros doivent être identiques",
                        { number: minSimilarPicks }
                    ),
                };
            }

            if (typeof maxSimilarPicks === "number" && maxSimilarPicks > 0 && duplicateCount > maxSimilarPicks) {
                return {
                    valid: false,
                    message: this.getTranslatedText(
                        "Les Deux numéros doivent être identiques",
                        { number: maxSimilarPicks }
                    ),
                };
            }

            return { valid: true };
        },

        validateMaxPerBall() {
            if (this.maxPerBall === -1) {
                return { valid: true };
            }

            const counts = this.selection.reduce((acc, num) => {
                if (num !== undefined) acc[num] = (acc[num] || 0) + 1;
                return acc;
            }, {});
           
            for (const [num, count] of Object.entries(counts)) {
                if (count > this.maxPerBall) {
                    return {
                        valid: false,
                        message: this.getTranslatedText(
                            "You can only select the number [number] [max_per_ball] time(s)!",
                            {
                                number: num,
                                max_per_ball: this.maxPerBall,
                            }
                        ),
                    }
                }
            }

            return { valid: true };
        },

        onAddToCart() {
            this.$store.state.isLoadingAddCart = true;
            if (this.selection.includes(undefined)) {
                const param = {
                    text: this.getTranslatedText(`Please make sure that you select [number] of balls!`, {
                        number: this.picks,
                    }),
                    type: "warning",
                };
                EventBus.$emit("show-notications", param);
                this.$store.state.isLoadingAddCart = false;

                return false;
            }

            const isCheckMaxPerBall = this.validateMaxPerBall();
            if (!isCheckMaxPerBall.valid) {
                const param = {
                    text: isCheckMaxPerBall.message,
                    type: "warning",
                };
                EventBus.$emit("show-notications", param);
                this.$store.state.isLoadingAddCart = false;
                return;
            }

            const isCheckSimilarPicks = this.validateSimilarPicks();
            if (!isCheckSimilarPicks.valid) {
                const param = {
                    text: isCheckSimilarPicks.message,
                    type: "warning",
                };
                EventBus.$emit("show-notications", param);
                this.$store.state.isLoadingAddCart = false;
                return;
            }

            const param = this.dataSource;

            param["title"] = this.dataSource.title;
            param["selection"] = this.selection;
            param["totalCart"] = this.totalWager;
            param["gameType"] = CT_PICK_3.SLUG_GAME;
            param["market"] = this.selectedMarket;
            param["wager"] = this.wager;
            param["id"] = new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, "");
            this.$store.dispatch("onAddToCart", param);
            this.onClearSelectNumber();
            localStorage.removeItem(CT_PICK_3.LOCAL_STORAGE_KEY);
        },

        onSelectMarket(market) {
            this.selectedMarket = market;
            this.renderConfigFollowMarket(market);
            this.selection = Array(this.picks).fill(undefined);
        },

        // select number
        onSelectNumber(number, pickIndex) {
            if (this.selection[pickIndex] === number) {
                this.$set(this.selection, pickIndex, undefined);
            } else {
                this.$set(this.selection, pickIndex, number);
            }
        },

        // uti render
        renderPrice(price, decimal = 0) {
            return formatPrice(price, decimal);
        },
    },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/games/_number.scss";
</style>
